import axios from 'axios'

const API_URL = process.env.API_BASE_URL || ''

export const client = axios.create({
  baseURL: API_URL,
  withCredentials: true
})

// Interceptor de requisição: normaliza campos legados do vue-resource (body -> data, credentials -> withCredentials)
client.interceptors.request.use((config) => {
  if (config.body !== undefined && config.data === undefined) {
    config.data = config.body
  }
  if (config.credentials !== undefined && config.withCredentials === undefined) {
    config.withCredentials = config.credentials
  }
  if (typeof FormData !== 'undefined' && config.data instanceof FormData && config.headers) {
    // Permite que o browser / axios calcule o boundary correto para multipart/form-data
    if (config.headers['Content-Type'] === 'multipart/form-data') {
      delete config.headers['Content-Type']
    }
  }
  return config
})

// Interceptor de resposta: normaliza compatibilidade com vue-resource (response.body, error.body, error.status)
client.interceptors.response.use(
  (response) => {
    if (response && response.body === undefined) {
      response.body = response.data
    }
    return response
  },
  (error) => {
    if (error && error.response) {
      error.status = error.response.status
      error.body = error.response.data
      error.data = error.response.data
    }
    return Promise.reject(error)
  }
)

export const http = function (config) {
  return http.request(config)
}

http.request = function (config) {
  return client.request(config)
}

http.get = (url, config = {}) => client.get(url, config)
http.post = (url, data, config = {}) => client.post(url, data, config)
http.put = (url, data, config = {}) => client.put(url, data, config)
http.patch = (url, data, config = {}) => client.patch(url, data, config)
http.delete = (url, config = {}) => client.delete(url, config)
http.client = client

export default http
